module.exports = __webpack_public_path__ + "static/media/logo-gebrov4.bfa70806.svg";